(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LoginViewModel', LoginViewModelFactory);

  /** @ngInject */
  function LoginViewModelFactory () {
    function LoginViewModel () {
      init.call(this);
    }

    LoginViewModel.prototype.destroy = function () {

    };

    return LoginViewModel;

    function init () {
      this.hasErrors = false;
      this.errorMessage = "";
      this.languages = [
        {
          id: 'en',
          name: 'English'
        },
        {
          id: 'sr',
          name: 'Srpski'
        },
        {
          id: 'de',
          name: 'Deutsch'
        },
        {
          id: 'fr',
          name: 'Français'
        },
        {
          id: 'hr',
          name: 'Hrvatski'
        },
        {
          id: 'pl',
          name: 'Polski'
        },
        {
          id: 'sl',
          name: 'Slovenščina'
        },
        {
          id: 'cs',
          name: 'Čeština'
        },
        {
          id: 'uk',
          name: 'Український'
        },
        {
          id: 'hu',
          name: 'Magyar'
        },
        {
          id: 'ru',
          name: 'Pусский'
        },
        {
          id: 'ro',
          name: 'Română'
        },
        {
          id: 'nl',
          name: 'Dutch'
        },
        {
          id: 'sv',
          name: 'Swedish'
        },
        {
          id: 'fi',
          name: 'Finnish'
        },
        {
          id: 'tw',
          name: 'Chinese (Traditional)'
        },
        {
          id: 'sk',
          name: 'Slovenský'
        }
      ];

      this.selectedLanguageId = localStorage.getItem('language') || 'en';
      this.email = '';
      this.password = '';
    }
  }
})();
